import getBasePath from '../functions/api-resource';

const basePath = getBasePath('apuracao_acao', 'configuracao');

const configuracaoActions = {
};

export default (resource) => resource(`${basePath}`, {}, configuracaoActions);
